import { render } from "./RegistrationsListView.vue?vue&type=template&id=7c0bb316&scoped=true"
import script from "./RegistrationsListView.vue?vue&type=script&lang=js"
export * from "./RegistrationsListView.vue?vue&type=script&lang=js"

import "./RegistrationsListView.vue?vue&type=style&index=0&id=7c0bb316&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0bb316"]])

export default __exports__